import React from 'react';
import DynamicPriceBuilderAdjustments from './tabs/DynamicPriceBuilderAdjustments';
import DynamicPriceBuilderGeneral from './tabs/DynamicPriceBuilderGeneral';
import DynamicPriceBuilderWorkspace from './DynamicPriceBuilderWorkspace';
import Tabs from '../Tabs/Tabs';
class DynamicPriceBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      code: this.props.code,
      status: this.props.status,
      start_date: this.props.start_date,
      end_date: this.props.end_date,
      begin_days_out: this.props.begin_days_out,
      end_days_out: this.props.end_days_out,
      dynamic_price_adjustments: this.props.dynamic_price_adjustments,
 
    }
  }

  render() {
    return (
      <div className="dynamic-price-builder">
        <h2>Dynamic Price: {this.props.name}</h2>
        <p>Code: {this.props.code}</p>
        <p>Status: {this.props.status}</p>
        <pre>{JSON.stringify(this.props, null, 2)}</pre>
      </div>
    );
  } 
}

export default DynamicPriceBuilder;